import { memo } from 'react';

interface MemoizedLogoProps {
  logoUrl?: string;
  companyName: string;
  isWhiteLabel: boolean;
  className?: string;
  fallbackSrc?: string;
  fallbackAlt?: string;
}

const MemoizedLogo = memo(({
  logoUrl,
  companyName,
  isWhiteLabel,
  className = "h-40 w-auto max-w-full object-contain",
  fallbackSrc = "https://i.imgur.com/VAuAJzp.png",
  fallbackAlt = "AI Employee Logo"
}: MemoizedLogoProps) => {
  if (!isWhiteLabel || !logoUrl) {
    return (
      <img
        src={fallbackSrc}
        alt={fallbackAlt}
        className={className}
      />
    );
  }

  return (
    <img
      src={logoUrl}
      alt={companyName}
      className={className}
      onError={(e) => {
        // Fallback to default logo if partner logo fails to load
        const target = e.target as HTMLImageElement;
        target.src = fallbackSrc;
        target.alt = fallbackAlt;
      }}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary re-renders
  return (
    prevProps.logoUrl === nextProps.logoUrl &&
    prevProps.companyName === nextProps.companyName &&
    prevProps.isWhiteLabel === nextProps.isWhiteLabel &&
    prevProps.className === nextProps.className
  );
});

MemoizedLogo.displayName = 'MemoizedLogo';

export default MemoizedLogo;